import React from 'react';

interface LoadingSpinnerProps {
  size?: number,
  thickness?: number,
  color?: string,
}
const spinnerStyle = (size?: number, color?:string, thickness?: number): React.CSSProperties => ({
  width: `${size ?? 16}px`,
  height: `${size ?? 16}px`,
  border: `${thickness ?? 5}px solid rgba(255, 255, 255, 0.2)`,
  borderTop: `${thickness ?? 5}px solid ${color ?? 'blue'}`,
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
});

const containerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2px',
};

// Define keyframes using a <style> tag
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({size, color, thickness}) => (
  <>
    <style>
      {`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}
    </style>
    <div style={containerStyle}>
      <div style={spinnerStyle(size, color, thickness)} />
    </div>
  </>
);

export default LoadingSpinner;
